import React from 'react'
import styled from 'styled-components';
import {Consumer} from '../context/InfoContext'
import Row from '../dev/Row';
import Span from '../dev/Span'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
const Rank = (props) => {
    const { messages } = props
    const renderRanking = (value, isBlur) => <Span>{messages.info_rank_no_1} <Span isBlur={isBlur}>{value}</Span> {messages.info_rank_no_2}</Span>
    const renderPercentage = (value, isBlur) => <Span color='#de0606'>{messages.info_rank_percentage_1} <Span color='#de0606' isBlur={isBlur}>{value}</Span>% {messages.info_rank_percentage_2}</Span>
    return (
        <Consumer>{value=>
            <RankDefault>
                <Row padding='24px' borderbottom>
                    <Span spanTitle>{value.country} {messages.rank}</Span>
                </Row>
                <Row padding='16px 24px' content='space-between' lineHeight="1.1rem">
                    <Row width='auto'>
                        <Row direction='column' whiteSpace='nowrap' width='auto'>
                            <Span>{messages.subscriberCount}</Span>
                            <Span>{messages.todaySubscriberCount}</Span>
                            <Span>{messages.monthViewCount}</Span>
                            <Span>{messages.monthSubscriberCount}</Span>
                        </Row>
                        <Row direction='column' width='auto' padding='0 0 0 16px'>
                            {renderRanking(value.subscribersRank, value.isBlur)}
                            {renderRanking(value.todaySubscriberRank, value.isBlur)}
                            {renderRanking(value.monthViewRank, value.isBlur)}
                            {renderRanking(value.monthSubscriberRank, value.isBlur)}
                        </Row>
                        <Row direction='column' width='auto' padding='0 0 0 16px'>
                            {renderPercentage(value.subscribersRankPercentage, value.isBlur)}
                            {renderPercentage(value.todaySubscriberRankPercentage, value.isBlur)}
                            {renderPercentage(value.monthViewRankPercentage, value.isBlur)}
                            {renderPercentage(value.monthSubscriberRankPercentage, value.isBlur)}
                        </Row>
                    </Row>
                    <Row width='auto' minWidth='50%'>
                        <Row direction='column' whiteSpace='nowrap' width='auto'>
                            <Span>{messages.monthViewRate}</Span>
                            <Span>{messages.monthSubscriberRate}</Span>
                            <Span>{messages['20_avg_views']}</Span>
                            <Span>{messages['20_avg_engage']}</Span>
                        </Row>
                        <Row direction='column' width='auto' padding='0 0 0 16px'>
                            {renderRanking(value.monthViewRateRank, value.isBlur)}
                            {renderRanking(value.monthSubscriberRateRank, value.isBlur)}
                            {renderRanking(value.recentAvgViewRank, value.isBlur)}
                            {renderRanking(value.recentAvgEngageRateRank, value.isBlur)}
                        </Row>
                        <Row direction='column' width='auto' padding='0 0 0 16px'>
                            {renderPercentage(value.monthViewRateRankPercentage, value.isBlur)}
                            {renderPercentage(value.monthSubscriberRateRankPercentage, value.isBlur)}
                            {renderPercentage(value.recentAvgViewRankPercentage, value.isBlur)}
                            {renderPercentage(value.recentAvgEngageRateRankPercentage, value.isBlur)}
                        </Row>
                    </Row>
                </Row>
            </RankDefault>
        }</Consumer>
    )
}
const mapStateToProps = state => {
    return {
        messages: state.Messages
    }
}
export default withRouter(connect(mapStateToProps)(Rank));
//export default Rank;

const RankDefault = styled.div`
    grid-area: rank;
    display: flex;
    flex-direction: column;
    background-color: #fff;
    height: auto;
    box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.05);
`







// WEBPACK FOOTER //
// ./src/Info/Rank.js